export default __webpack_public_path__ + "static/media/ExecutiveSeat.0511c949.svg";